/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { Application, ApplicationList, UserPermission } from '../../data/interfaces';
import {
    CREATE_APPLICATION_FAILURE, CREATE_APPLICATION_REQUEST, CREATE_APPLICATION_SUCCESS,
    DELETE_APPLICATION_FAILURE, DELETE_APPLICATION_REQUEST, DELETE_APPLICATION_SUCCESS,
    FETCH_APPLICATION_DETAILS_FAILURE, FETCH_APPLICATION_DETAILS_REQUEST, FETCH_APPLICATION_DETAILS_SUCCESS,
    FETCH_APPLICATION_FAILURE, FETCH_APPLICATION_REQUEST, FETCH_APPLICATION_SUCCESS,
    SHARE_APPLICATION_FAILURE, SHARE_APPLICATION_REQUEST, SHARE_APPLICATION_SUCCESS,
    UPDATE_APPLICATION_FAILURE, UPDATE_APPLICATION_REQUEST, UPDATE_APPLICATION_SUCCESS
} from '../types/applications';

export const fetchApplicationRequest = () => {
    return {
        type: FETCH_APPLICATION_REQUEST
    }
}

export const fetchApplicationSuccess = (applications: ApplicationList) => {
    return {
        type: FETCH_APPLICATION_SUCCESS,
        payload: applications
    }
}

export const fetchApplicationFailure = (error: string) => {
    return {
        type: FETCH_APPLICATION_FAILURE,
        payload: error
    }
}

export const fetchApplicationDetailsRequest = () => {
    return {
        type: FETCH_APPLICATION_DETAILS_REQUEST
    }
};

export const fetchApplicationDetailsSuccess = (application: Application) => {
    return {
        type: FETCH_APPLICATION_DETAILS_SUCCESS,
        payload: application
    }
};

export const fetchApplicationDetailsFailure = (error: string) => {
    return {
        type: FETCH_APPLICATION_DETAILS_FAILURE,
        payload: error
    }
};

export const createApplicationRequest = () => {
    return {
        type: CREATE_APPLICATION_REQUEST
    }
}

export const createApplicationSuccess = (applications: Application) => {
    return {
        type: CREATE_APPLICATION_SUCCESS,
        payload: applications
    }
}

export const createApplicationFailure = (error: string) => {
    return {
        type: CREATE_APPLICATION_FAILURE,
        payload: error
    }
}

export const updateApplicationRequest = () => {
    return {
        type: UPDATE_APPLICATION_REQUEST
    }
};

export const updateApplicationSuccess = (application: Application) => {
    return {
        type: UPDATE_APPLICATION_SUCCESS,
        payload: application
    }
};

export const updateApplicationFailure = (error: string) => {
    return {
        type: UPDATE_APPLICATION_FAILURE,
        payload: error
    }
};

export const deleteApplicationRequest = () => {
    return {
        type: DELETE_APPLICATION_REQUEST
    }
}

export const deleteApplicationSuccess = (applicationId: string) => {
    return {
        type: DELETE_APPLICATION_SUCCESS,
        payload: applicationId,
    }
}

export const deleteApplicationFailure = (error: string) => {
    return {
        type: DELETE_APPLICATION_FAILURE,
        payload: error
    }
}

export const shareApplicationRequest = (applicationId: string, userPermissions: UserPermission[]) => {
    return {
        type: SHARE_APPLICATION_REQUEST,
        payload: {
            applicationId,
            userPermissions
        }
    }
}

export const shareApplicationSuccess = (application: Application) => {
    return {
        type: SHARE_APPLICATION_SUCCESS,
        payload: application
    }
}

export const shareApplicationFailure = (error: string) => {
    return {
        type: SHARE_APPLICATION_FAILURE,
        payload: error
    }
}
